import { createRoot } from "react-dom/client";

import { AppProviders } from "./app/providers";
import { setupVisualViewportLayoutBridge } from "./app/visualViewportLayout";
import { setupServiceWorkerNotificationNavigationBridge } from "./features/notifications/notificationNavigationBridge";
import { applyInitialDocumentTheme } from "./features/theme/theme";
import "./styles/app.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("root element not found");
}

setupServiceWorkerNotificationNavigationBridge();
applyInitialDocumentTheme();
setupVisualViewportLayoutBridge();

createRoot(rootElement).render(
  <AppProviders />,
);
